import session from './session'

export default {

  /**
   * Справочники.
   * Получить из REST все доступные пользователю панели NGS библиотек,
   * чтобы он мог их выбирать при создании библиотеки.
   * Здесь же настройки библиотек по умолчанию для панелей
   * @returns {AxiosPromise<any>}
   */
  getNgsPanels() {
    return session.get('/ngs_panel/')
  },
}